import cx from "classnames";
import React, { ReactNode } from "react";

import { PolymorphicComponentProps } from "../../helpers";
import * as styles from "./Row.module.css";

interface IRowProps {
  className?: string;
  children?: ReactNode;
}
export type RowProps<E extends React.ElementType> = Readonly<IRowProps> &
  PolymorphicComponentProps<E>;
export const Row = <E extends React.ElementType>(props: RowProps<E>) => {
  const { className, children, as: Component = "div", ...restProps } = props;

  return (
    <Component className={cx(styles.row, className)} {...restProps}>
      {children}
    </Component>
  );
};
